<template>
  <div class="login-main-background">
    <div class="login-main-container">
      <div class="row no-gutters">
        <div class="col-sm-8 col-12">
          <img src="/glass/img/front-logo.png" class="login-synergy-logo" />
          <div class="login-form row">
            <div class="col-10 offset-1 col-sm-10 offset-sm-1 text-center">
              <slot name="main" />
            </div>
          </div>
        </div>

        <div class="col-0 col-sm-4 login-side-bar">
          <div class="login-side-inner">
            <slot name="sidebar" />
          </div>          
        </div>
      </div>
    </div>

    <p class="login-footer-area">
      <span v-html="`${appCopyrightInfo}`"></span>
      <span class="mx-2 login-footer-seperator">&bull;</span>
      <router-link to="/about/terms">Terms of use</router-link>
      <span class="mx-2 login-footer-seperator">&bull;</span>
      <router-link to="/about/privacy">Privacy</router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: 'LoginWrapper',
  computed: {
    appCopyrightInfo() {
      return this.$store.state.system.appCopyrightInfo
    },
    appVersion() {
      return this.$store.state.system.appVersion
    }
  }
}
</script>